var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-detail-text"},[_c('div',{staticClass:"flex items-center"},[_c('div',[_c('div',{staticClass:"color-circle mr-2",style:(_vm.style)})]),_c('div',{staticClass:"aisea-text-12-400-dark-gray"},[_vm._v(_vm._s(_vm.text))])]),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }